<template>
   <div class="block-section" id="info_box">
      <info-box-header
         :title="title"
         :exp_switch="exp_switch"
         :exp_on="exp_on"
         :expanded="expanded"
         @expChange="$emit('expChange')"
         @toggleShow="expanded = !expanded"
      ></info-box-header>

      <div class="block-section-wrapper" :class="{centerContent: centerContent, hide: !expanded, schedHeight: height}">
         <slot></slot>
      </div>
   </div>
</template>

<script>

export default {
   data() {
      return {
         expanded: true
      }
   },

   computed: {
   },

   props: [
      'title',
      'exp_switch',
      'exp_on',
      'centerContent',
      'height'
   ],
}
</script>


<style lang="scss" scoped>
.block-section {
   border-top: 1px solid #334b69;
   background-color: $box-blue;
   padding-top: 2px;
   padding-right: 0;
   padding-left: 0;
}

.block-section-wrapper {
   padding: 10px 20px;

   &.centerContent {
      text-align: center;
   }

   &.hide {
      display: none;
   }

   &.schedHeight {
      height: 368px;
   }
}

.block-box-label {
   text-transform: uppercase;
   color: $gray-text;
   font-size: 14px;
}
</style>

